var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrashGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_trash_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-04-open",
    transform: "translate(-1090.000000, -2458.000000)",
    fill: "#5E6C80",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(522.000000, 1780.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 564.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(10.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(557.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(1.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8,0 C11.7928,0 12.6,0.8072 12.6,1.8 L12.6,2.4 L17.4,2.4 C17.7312,2.4 18,2.6688 18,3 C18,3.3312 17.7312,3.6 17.4,3.6 L16.152,3.6 L15.0896,16.3496 C15.0128,17.2752 14.2248,18 13.296,18 L4.7048,18 C3.776,18 2.988,17.2752 2.9112,16.3488 L1.848,3.6 L0.6,3.6 C0.2688,3.6 0,3.3312 0,3 C0,2.6688 0.2688,2.4 0.6,2.4 L5.4,2.4 L5.4,1.8 C5.4,0.8072 6.2072,0 7.2,0 L10.8,0 Z M14.948,3.6 L3.052,3.6 L4.1064,16.2496 C4.132,16.5584 4.3944,16.8 4.7048,16.8 L13.296,16.8 C13.6056,16.8 13.8688,16.5584 13.8936,16.2496 L14.948,3.6 Z M7.2,6.6 C7.5312,6.6 7.8,6.8688 7.8,7.2 L7.8,13.2 C7.8,13.5312 7.5312,13.8 7.2,13.8 C6.8688,13.8 6.6,13.5312 6.6,13.2 L6.6,7.2 C6.6,6.8688 6.8688,6.6 7.2,6.6 Z M10.8,6.6 C11.1312,6.6 11.4,6.8688 11.4,7.2 L11.4,13.2 C11.4,13.5312 11.1312,13.8 10.8,13.8 C10.4688,13.8 10.2,13.5312 10.2,13.2 L10.2,7.2 C10.2,6.8688 10.4688,6.6 10.8,6.6 Z M10.8,1.2 L7.2,1.2 C6.8688,1.2 6.6,1.4688 6.6,1.8 L6.6,2.4 L11.4,2.4 L11.4,1.8 C11.4,1.4688 11.1312,1.2 10.8,1.2 Z",
    id: "icon_trash_gray"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashGray);
export default __webpack_public_path__ + "static/media/icon_trash_gray.a9bf47d1298bce428df47a4f62ca5ee8.svg";
export { ForwardRef as ReactComponent };